import React from 'react';
import './styles.css';

const BadgeCount = ({ children }) => (
  <div className='drawer-badge'>
    <span className='drawer-badge-count'>{children}</span>
  </div>
);

export default BadgeCount;
